module.exports = __webpack_public_path__ + "static/media/ethical_intruder_logo.afee1ea8.jpg";